import type {
  IAoeWishListGetListResponse as IWishListGetListResponse,
  IWishlistSkuGetListResponse,
} from '@/types/WishListTypes.ts'
import { ApiPost, ApiDelete } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'

export async function WishListCreate(wishListName: string) {
  const url = await GetOrderEntryConnectorUrl('WishListCreate')
  return ApiPost(url, { wishListName })
}

export async function WishListDelete(wishListName: string) {
  const url = await GetOrderEntryConnectorUrl('WishListDelete')
  return ApiDelete(url, { wishListName })
}

export async function WishListGetList(): Promise<IWishListGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('WishListGetList')
  return ApiPost(url, null)
}

export async function WishlistSkuGetList(
  wishListName: string,
  orderTypeId: string,
): Promise<IWishlistSkuGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('WishlistSkuGetList')
  return ApiPost(url, { wishListName, orderTypeId })
}

export async function WishlistSkuCreate(
  wishListName: string | null,
  skuCode: string,
) {
  const url = await GetOrderEntryConnectorUrl('WishlistSkuCreate')
  return ApiPost(url, { wishListName, skuCode })
}

export async function WishlistSkuDelete(wishListName: string, skuCode: string) {
  const url = await GetOrderEntryConnectorUrl('WishlistSkuDelete')
  return ApiPost(url, { wishListName, skuCode })
}
